//SalesAverages.tsx ==============================================================
import "../Util/Prototypes";

import * as Default from "../Default";
import * as GetSales from "./GetSales";
import * as SalesResults from "./SalesResults";
import * as SalesSearch from "./SalesSearch";
import * as SalesSearchSettings from "./SalesSearchSettings";
import * as Settings from "../Settings";
import * as Util from "../Util/Util";

import { blueGrey } from '@mui/material/colors';

import React from "react";

export let refreshExternal: () => void; //Ref to refreshIt method inside render.

//Compute sales averages and adjusted price.
export function computeSalesAves() {
   const ss: SalesSearchSettings.iSS = SalesSearchSettings.ss;
   const improveTypeSpec: SalesSearchSettings.iImproveType = SalesSearchSettings.getImproveTypeSpec(SalesSearch.improvementType);

   GetSales.setAveSalesPricePrompt("Ave sale price");

   //Get subject size.
   let subjectSize: number = 0;

   if (improveTypeSpec.vacant) {
      GetSales.setPricePerSizePrompt("Ave price/acre");
      if (SalesSearch.activePIN) {
         subjectSize = ss.LotSize.subjectValue;
      }

   } else {
      GetSales.setPricePerSizePrompt("Ave price/sqft");
      if (SalesSearch.activePIN) {
         subjectSize = ss.StructureSize.subjectValue;
      }
   }

   GetSales.setAdjustedPricePrompt("");
   if (subjectSize > 0) {
      GetSales.setAdjustedPricePrompt("Adjusted price");
   }

   //Tally sales averages for all selected sales records.
   let pricePerSize: number;
   let numComps: number = 0;
   let totalAvePricePer: number = 0;
   let totalSalesPrice: number = 0;

   const numSel: number = SalesResults.getNumSelected();

   for (const feature of SalesSearch.layer.fs.features) {
      const gra = feature as any;

      if (gra.rowSelected || numSel === 0) {
         const atrs = feature.attributes;

         if (improveTypeSpec.vacant) {
            pricePerSize = atrs.pricePerAcre;
         } else {
            pricePerSize = atrs.pricePerSqFt;
         }

         if (pricePerSize > 0) {
            numComps++;
            totalAvePricePer += pricePerSize;
            totalSalesPrice += atrs[ss.SalePrice.field];
         }
      }
   }

   //Compute averages.
   let aveSalesPrice: number = 0;
   let avePricePerSize: number = 0;
   let adjustedPrice: number = 0;

   if (numComps > 0) {
      aveSalesPrice = Util.parseInteger((totalSalesPrice / numComps).toString());
      avePricePerSize = totalAvePricePer / numComps;
      if (subjectSize > 0) {
         adjustedPrice = Util.parseInteger((subjectSize * avePricePerSize).toString());
      }
   }

   GetSales.setAveSalesPriceTxt(Util.formatTextValue(aveSalesPrice, "Money"));
   GetSales.setAvePricePerSizeTxt(Util.formatTextValue(avePricePerSize, "Money"));
   GetSales.setAdjustedPriceTxt(Util.formatTextValue(adjustedPrice, "Money"));

   if (GetSales.aveSalesPriceTxt === "$0") {
      GetSales.setAveSalesPriceTxt("");
   }
   if (GetSales.avePricePerSizeTxt === "$0") {
      GetSales.setAvePricePerSizeTxt("");
   }
   if (GetSales.adjustedPriceTxt === "$0") {
      GetSales.setAdjustedPriceTxt("");
   }
}

interface iProps {
}

//Render function.
export function Render(props: iProps) {

   //Set refresh method.
   const [ignored, refresh] = React.useReducer((x: number) => x + 1, 0);

   //Begin external refresh. _________________________
   function refreshIt() {
      refresh();
   }
   const refreshRef = React.useRef(refreshIt);

   //Component did mount.
   React.useEffect(() => {
      refreshExternal = refreshRef.current;
   }, []);
   //End external refresh. _____________________________

   //Module variables.
   let adjustedVisible: boolean = false;
   if (SalesSearch.activePIN) {
      adjustedVisible = true;
   }

   //Styling.
   const styles: Default.iStyles = {
      table: { width: '97%', fontWeight: 500, borderCollapse: 'collapse', borderSpacing: 0 },
      headingCell: { padding: 2, border: '1px solid silver', backgroundColor: blueGrey[50], fontWeight: 400, textAlign: 'center' },
      bodyCell: { padding: 2, border: '1px solid silver', backgroundColor: 'white', fontWeight: 500, textAlign: 'center' },
   };

   if (Settings.security.accessLevel < SalesSearchSettings.ss.accessLevel_salesAverage) {
      return (<span />); //Quit if not showing sales averages.
   }

   return (
      <table style={styles.table}>
         <thead>
            <tr>
               <th style={styles.headingCell}>{GetSales.aveSalesPricePrompt}</th>
               <th style={styles.headingCell}>{GetSales.pricePerSizePrompt}</th>
               {adjustedVisible && <th style={styles.headingCell}>{GetSales.adjustedPricePrompt}</th>}
            </tr>
         </thead>

         <tbody style={styles.body}>
            <tr>
               <td style={styles.bodyCell}>{GetSales.aveSalesPriceTxt}</td>
               <td style={styles.bodyCell}>{GetSales.avePricePerSizeTxt}</td>
               {adjustedVisible && <td style={styles.bodyCell}>{GetSales.adjustedPriceTxt}</td>}
            </tr>

         </tbody>
      </table>
   ); //end return.

} //end function.
